export default "__VITE_ASSET__DtpAnDh___"